import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import ReactStrapTable from 'components/reactStrapTable';

import useAxios from 'hooks/useAxios';
import { dateFormate, cellRendererCheck, currencyFormat } from 'utils/columns';

const ClaimHistory = ({ tenantID, claimID }) => {
  const API = useAxios();
  const [loading, setLoading] = useState(false);
  const [claimHistory, setClaimHistory] = useState([]);

  useEffect(() => {
    getClaimHistory();
  }, []);

  const getClaimHistory = async () => {
    try {
      setLoading(true);
      const { data } = await API.get(`/${tenantID}/Claim/History/${claimID}`, {
        hideLoader: true,
      });
      setClaimHistory(data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataField: 'claimStatus',
      text: 'Claim Status',
      width: 60,
      cellRenderer: (row) => cellRendererCheck(row.claimStatus),
      show: true
    },
    {
      dataField: 'reasonDesc',
      text: 'Reason',
      width: 60,
      cellRenderer: (row) => cellRendererCheck(row.reasonDesc),
      show: true
    },
    {
      dataField: 'dispensingFee',
      text: 'Dispensing Fee',
      width: 60,
      cellRenderer: (row) => currencyFormat(row.dispensingFee),
      show: true
    },
    {
      dataField: 'ceReceivable',
      text: 'CE Receivable',
      width: 60,
      cellRenderer: (row) => currencyFormat(row.ceReceivable),
      show: true
    },
    {
      dataField: 'drugCost340B',
      text: 'Drug Cost',
      width: 60,
      cellRenderer: (row) => currencyFormat(row.drugCost340B),
      show: true
    },
    {
      dataField: 'profitLoss',
      text: 'Profit/Loss',
      width: 60,
      cellRenderer: (row) => currencyFormat(row.profitLoss),
      show: true
    },
    {
      dataField: 'Change Date ',
      text: 'Change Date',
      width: 60,
      cellRenderer: (rowData) => dateFormate(rowData.createdDate),
      show: true
    },
    {
      dataField: 'createdBy',
      text: ' Change By ',
      width: 60,
      cellRenderer: (row) => cellRendererCheck(row.createdBy),
      show: true
    },
  ];

  return (
    <Card className='border-0 rounded-bottom-1 table-card'>
      <CardBody>
        <ReactStrapTable
          id='claimhistory'
          height={50 * claimHistory.length}
          columns={columns}
          data={claimHistory}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};

export default ClaimHistory;
